export default "__VITE_ASSET__gfqTBf7l__"